export const semanticColors = {
  // Base colors
  white: "#FFFFFF",
  black: "#212121",
  // Primary colors
  sapphireBlue: "sapphireBlue.500",
  blueGray: "blueGray.500",
  sunnyYellow: "yellow.500",
  // System colors
  success: "green.500",
  error: "red.500",
  info: "blue.500",
  warning: "yellow.500",
  // Background
  darkBlue: "#1C2335",
};

export const colors = {
  // Palette
  blueGray: {
    50: "#FCFDFF",
    100: "#E3EFFF",
    200: "#E3E8EF",
    300: "#D4DCE6",
    400: "#C6D1DE",
    500: "#B8C5D6",
    600: "#A6B1C1",
    700: "#8F9CAD",
    800: "#818A96",
    900: "#6E7680",
  },
  sapphireBlue: {
    50: "#F4F4FF",
    100: "#C4C2FF",
    200: "#9391FF",
    300: "#6663D6",
    400: "#3D3BA3",
    500: "#1F1D70",
    600: "#0F0D5A",
    700: "#100F38",
    800: "#090922",
    900: "#03030B",
  },
  blue: {
    50: "#EDF4FF",
    100: "#B9D5FF",
    200: "#84B5FF",
    300: "#5096FF",
    400: "#3F88F6",
    500: "#2A6ED4",
    600: "#1956B2",
    700: "#0C4190",
    800: "#032E6E",
    900: "#001E4C",
  },
  yellow: {
    50: "#FFF9E5",
    100: "#FFE899",
    200: "#FFE589",
    300: "#FFD84C",
    400: "#FFD12E",
    500: "#FFC700",
    600: "#D6A700",
    700: "#AD8700",
    800: "#846700",
    900: "#5C4800",
  },
  red: {
    50: "#FFEDED",
    100: "#FFC4C4",
    200: "#FF9F9F",
    300: "#FF7373",
    400: "#F34747",
    500: "#D13131",
    600: "#AF1F1F",
    700: "#8D1111",
    800: "#6B0707",
    900: "#490101",
  },
  green: {
    50: "#F2FFF8",
    100: "#BAFFDA",
    200: "#81FFBC",
    300: "#5BD493",
    400: "#4EC385",
    500: "#38A169",
    600: "#257F4F",
    700: "#165D37",
    800: "#22543D",
    900: "#1C4532",
  },
  // Alpha Palette
  whiteAlpha: getAlphaColorPalette("255, 255, 255"),
  blackAlpha: getAlphaColorPalette("33, 33, 33"),
  blueGrayAlpha: getAlphaColorPalette("184, 197, 214"),
  sapphireBlueAlpha: getAlphaColorPalette("31, 29, 112"),
  blueAlpha: getAlphaColorPalette("42, 110, 212"),
  yellowAlpha: getAlphaColorPalette("255, 199, 0"),
  redAlpha: getAlphaColorPalette("209, 49, 49"),
  greenAlpha: getAlphaColorPalette("56, 161, 105"),
  // special palette for alpha components
  alphaDark: {
    500: getAlphaColorPalette("255, 255, 255")[200],
    600: getAlphaColorPalette("255, 255, 255")[100],
    700: getAlphaColorPalette("255, 255, 255")[50],
  },
  alphaLight: {
    500: getAlphaColorPalette("42, 110, 212")[100],
    600: getAlphaColorPalette("42, 110, 212")[200],
    700: getAlphaColorPalette("42, 110, 212")[300],
  },
};

function getAlphaColorPalette(color: string) {
  const pattern = {
    50: "0.04",
    100: "0.1",
    200: "0.2",
    300: "0.3",
    400: "0.4",
    500: "0.5",
    600: "0.6",
    700: "0.7",
    800: "0.8",
    900: "0.9",
  } as { [key: number]: string };

  Object.keys(pattern).forEach((key) => {
    pattern[Number(key)] = `rgba(${color}, ${pattern[Number(key)]})`;
  });

  return pattern;
}
